import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, isRef as _isRef } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("添加团队");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("设置角色");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "relation-cell"
};
const _hoisted_6 = {
  class: "relation-text"
};
const _hoisted_7 = {
  class: "relation-cell"
};
const _hoisted_8 = {
  class: "relation-text"
};
const _hoisted_9 = {
  class: "relation-cell"
};
const _hoisted_10 = {
  class: "relation-text"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { addSalesmanMan, getSalesmanDetail } from '@/request';
import { getVexTableProps } from '@/config';
import { ElMessage, ElMessageBox } from 'element-plus';
import { arrayRemoveRepeatByProp } from '@/utils';
import AddTeamModal from '@/components/AddTeamModal.vue';
import RelationSupplierBranchModal from './RelationSupplierBranchModal.vue';
import SetRoleModal from './SetRoleModal.vue';
import DepartmentTreeModal from './DepartmentTreeModal.vue';
import SalesAreaTreeModal from './SalesAreaTreeModal.vue';
export default {
  name: 'AddSalesmanModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    editData: {
      type: [null, Object],
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const showAddTeamModal = ref(false);
    const showAddSalesManModal = ref(false);
    const supplierId = ref('');
    const showSetRoleModal = ref(false);
    const showDepartmentTreeModal = ref(false);
    const currentDepartmentRowIndex = ref(-1);
    const currentDepartmentSupplierId = ref('');
    const showSalesAreaTreeModal = ref(false);
    const currentSalesAreaRowIndex = ref(-1);
    const currentSalesAreaAdcode = ref('');
    const store = useStore();
    /** 当前登录账号类型：2=分管（admin/information/getUserType.json） */

    const loginUserType = computed(() => store.state.user.userType);
    const formRef = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const defaultForm = {
      loginName: '',
      linkPhone: '',
      linkMan: '',
      note: ''
    };
    const table = ref();
    const form = ref(_objectSpread({}, defaultForm));
    const columns = [{
      type: 'checkbox',
      width: '50px',
      fixed: 'left'
    }, {
      title: '团队名称',
      field: 'supplier_name',
      width: '150px',
      showOverflow: false
    }, {
      title: '部门名称',
      field: 'structureName',
      width: '200px',
      showOverflow: true,
      slots: {
        default: 'structureCell'
      }
    }, {
      title: '联系人',
      field: 'link_man',
      width: '150px',
      showOverflow: true
    }, {
      title: '后台权限',
      field: 'isLoginWeb',
      width: '160px',
      showOverflow: true,
      slots: {
        default: 'isLoginWeb'
      }
    }, {
      title: '团队角色',
      field: 'employeeType',
      width: '160px',
      showOverflow: true,
      slots: {
        default: 'employeeRole'
      }
    }, {
      title: 'APP端权限',
      field: 'appPermissionCodes',
      width: '280px',
      showOverflow: true,
      slots: {
        default: 'appPermissionCell'
      }
    }, {
      title: '首次加入时间',
      field: 'firstJoinTime',
      width: '180px',
      showOverflow: true
    }, {
      title: '联系电话',
      field: 'link_phone',
      width: '150px',
      showOverflow: true
    }, {
      title: '关联厂家/发货方',
      field: 'salesman_branch_name_cover',
      width: '200px',
      showOverflow: true,
      slots: {
        default: 'relationCell'
      }
    }, {
      title: '销售区域',
      field: 'salesmanBusinessAreaName',
      width: '200px',
      showOverflow: true,
      slots: {
        default: 'businessAreaCell'
      }
    }];
    const tableData = ref([]);
    /** APP端权限选项值（后续对接接口可沿用） */

    const APP_PERM_DATA_VIEW = 'DATA_VIEW';
    const APP_PERM_MERCHANDISE = 'MERCHANDISE';
    const APP_PERM_MEMBER_AUDIT = 'MEMBER_AUDIT';
    const APP_PERM_PURCHASE_PRICE = 'PURCHASE_PRICE';
    const APP_PERM_OPTIONS_BASE = [{
      value: APP_PERM_DATA_VIEW,
      label: '数据查看权限'
    }, {
      value: APP_PERM_MERCHANDISE,
      label: '商品管理权限'
    }, {
      value: APP_PERM_MEMBER_AUDIT,
      label: '新成员审核权限'
    }];
    const APP_PERM_OPTION_PURCHASE_PRICE = {
      value: APP_PERM_PURCHASE_PRICE,
      label: '采购价查看权限'
    };
    const APP_PERM_OPTION_DATA_VIEW = APP_PERM_OPTIONS_BASE.find(o => o.value === APP_PERM_DATA_VIEW);
    /** 部门负责人固定可见：数据查看权限 */

    function getDeptHeadAppPermOptionsForRow(row) {
      const options = [APP_PERM_OPTION_DATA_VIEW];

      if (canShowPurchasePricePermOption(row)) {
        options.push(APP_PERM_OPTION_PURCHASE_PRICE);
      }

      return options;
    }
    /** 商业流向管控团队：非销售团队(supplier_category !== 2) */


    function isFlowControlSupplierTeam(row) {
      var _row$supplier_categor;

      const sc = Number((_row$supplier_categor = row.supplier_category) !== null && _row$supplier_categor !== void 0 ? _row$supplier_categor : row.supplierCategory);
      return sc !== 2;
    }
    /** 当前登录账号为分管角色 */


    function isLoginFenguanAccount() {
      return Number(loginUserType.value) === 2;
    }
    /** 采购价查看权限：分管登录 + 商业流向管控团队 + 企业负责人/部门负责人 */


    function canShowPurchasePricePermOption(row) {
      const et = Number(row.employeeType);
      return isLoginFenguanAccount() && (et === 1 || et === 2) && isFlowControlSupplierTeam(row);
    }

    function getAppPermOptionsForRow(row) {
      if (!canShowPurchasePricePermOption(row)) {
        return APP_PERM_OPTIONS_BASE;
      }

      return [...APP_PERM_OPTIONS_BASE, APP_PERM_OPTION_PURCHASE_PRICE];
    }

    function stripInvalidAppPermissionCodes(row) {
      const et = Number(row.employeeType);
      const allowed = new Set((et === 2 ? getDeptHeadAppPermOptionsForRow(row) : getAppPermOptionsForRow(row)).map(o => o.value));
      row.appPermissionCodes = (row.appPermissionCodes || []).filter(code => allowed.has(code));
    }

    function syncAppPermissionsForEmployeeType(row) {
      const et = Number(row.employeeType);

      if (et === 1) {
        row.appPermissionCodes = [APP_PERM_DATA_VIEW, APP_PERM_MERCHANDISE, APP_PERM_MEMBER_AUDIT];
      } else if (et === 2) {
        row.appPermissionCodes = [APP_PERM_DATA_VIEW];
      } else {
        row.appPermissionCodes = [];
      }

      stripInvalidAppPermissionCodes(row);
    }

    function onEmployeeTypeChange(row) {
      syncAppPermissionsForEmployeeType(row);
    }

    function onAppPermissionUpdate(row, val) {
      const next = Array.isArray(val) ? [...val] : [];

      if (!next.includes(APP_PERM_DATA_VIEW)) {
        next.push(APP_PERM_DATA_VIEW);
      }

      row.appPermissionCodes = next;
      stripInvalidAppPermissionCodes(row);
    }

    function toInt01(v) {
      return Number(v) === 1 ? 1 : 0;
    }
    /** 编辑回显：根据库字段 + 团队角色还原多选 */


    function applyServerAppAuthsToRow(row) {
      var _row$dataViewAuth, _row$prodManagerAuth, _row$newUserAuditAuth, _row$purchasePriceVie;

      const et = Number(row.employeeType);
      const dv = toInt01((_row$dataViewAuth = row.dataViewAuth) !== null && _row$dataViewAuth !== void 0 ? _row$dataViewAuth : row.data_view_auth);
      const pm = toInt01((_row$prodManagerAuth = row.prodManagerAuth) !== null && _row$prodManagerAuth !== void 0 ? _row$prodManagerAuth : row.prod_manager_auth);
      const nu = toInt01((_row$newUserAuditAuth = row.newUserAuditAuth) !== null && _row$newUserAuditAuth !== void 0 ? _row$newUserAuditAuth : row.new_user_audit_auth);
      const pp = toInt01((_row$purchasePriceVie = row.purchasePriceViewAuth) !== null && _row$purchasePriceVie !== void 0 ? _row$purchasePriceVie : row.purchase_price_view_auth);

      if (et === 3) {
        row.appPermissionCodes = [];
        return;
      }

      if (et === 2) {
        const codes = [APP_PERM_DATA_VIEW];

        if (canShowPurchasePricePermOption(row) && pp) {
          codes.push(APP_PERM_PURCHASE_PRICE);
        }

        row.appPermissionCodes = codes;
        return;
      }

      const codes = [];
      if (dv) codes.push(APP_PERM_DATA_VIEW);
      if (pm) codes.push(APP_PERM_MERCHANDISE);
      if (nu) codes.push(APP_PERM_MEMBER_AUDIT);

      if (canShowPurchasePricePermOption(row) && pp) {
        codes.push(APP_PERM_PURCHASE_PRICE);
      }

      if (!codes.includes(APP_PERM_DATA_VIEW)) {
        codes.unshift(APP_PERM_DATA_VIEW);
      }

      row.appPermissionCodes = codes;
      stripInvalidAppPermissionCodes(row);
    }
    /** 提交：与 tb_sup_salesman_info 权限字段对齐 */


    function rowToAppAuthFields(row) {
      const et = Number(row.employeeType);

      if (et === 3) {
        return {
          dataViewAuth: 0,
          prodManagerAuth: 0,
          newUserAuditAuth: 0,
          purchasePriceViewAuth: 0
        };
      }

      if (et === 2) {
        const codes = row.appPermissionCodes || [];
        const canPurchase = canShowPurchasePricePermOption(row);
        return {
          dataViewAuth: 1,
          prodManagerAuth: 0,
          newUserAuditAuth: 0,
          purchasePriceViewAuth: canPurchase && codes.includes(APP_PERM_PURCHASE_PRICE) ? 1 : 0
        };
      }

      const codes = row.appPermissionCodes || [];
      const canPurchase = canShowPurchasePricePermOption(row);
      return {
        dataViewAuth: codes.includes(APP_PERM_DATA_VIEW) ? 1 : 0,
        prodManagerAuth: codes.includes(APP_PERM_MERCHANDISE) ? 1 : 0,
        newUserAuditAuth: codes.includes(APP_PERM_MEMBER_AUDIT) ? 1 : 0,
        purchasePriceViewAuth: canPurchase && codes.includes(APP_PERM_PURCHASE_PRICE) ? 1 : 0
      };
    }

    function initEditData() {
      getSalesmanDetail({
        supAccountId: props.editData.supAccountId
      }).then(data => {
        if (data.success) {
          const {
            loginName,
            linkPhone,
            linkMan,
            note
          } = data.data; // 初始化表单

          form.value = {
            loginName,
            linkPhone,
            linkMan,
            supAccountId: props.editData.supAccountId,
            salesmanSupplierIdOld: props.editData.supplierId,
            note
          }; // 初始化团队

          tableData.value = data.data.salesmanList.map(i => {
            if (!i.businessCategory) {
              i.businessCategory = i.supplier_category === 1 ? '3' : '1';
            }

            if (i.employeeType === undefined || i.employeeType === null || i.employeeType === '') {
              i.employeeType = 3; // 默认业务员
            }

            if (i.isLoginWeb === undefined || i.isLoginWeb === null || i.isLoginWeb === '') {
              i.isLoginWeb = '0'; // 默认否
            }

            applyServerAppAuthsToRow(i);
            return i;
          });
        }
      });
    }

    watch(() => props.modelValue, newVal => {
      if (newVal && !props.editData) {
        var _formRef$value;

        (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
        tableData.value = [];
        form.value = _objectSpread({}, defaultForm);
      } else if (newVal && !props.isEdit) {
        initEditData();
      }
    }, {
      flush: 'post'
    });

    function addSuccess(list) {
      // supplier_category 1 厂家团队 2 发货方团队
      // 厂家团队默认给 业务员类型 3 商务经理
      // 发货方团队默认给 1 专职
      let rows = list.map(i => {
        i.businessCategory = i.supplier_category === 1 ? '3' : '1';

        if (i.employeeType === undefined || i.employeeType === null || i.employeeType === '') {
          i.employeeType = 3; // 默认业务员
        }

        if (i.isLoginWeb === undefined || i.isLoginWeb === null || i.isLoginWeb === '') {
          i.isLoginWeb = '0'; // 默认否
        }

        if (i.supplierBranchCoverList.length === 1) {
          i.salesman_branch_name_cover = i.supplierBranchCoverList[0].branch_name;
          i.salesman_branch_id_cover = i.supplierBranchCoverList[0].branch_id;
        } else {
          i.salesman_branch_name_cover = '-';
        }

        syncAppPermissionsForEmployeeType(i);
        return i;
      });

      if (rows && rows.length > 0) {
        tableData.value = arrayRemoveRepeatByProp(tableData.value.concat(rows), 'supplier_id');
      } else {
        console.error('添加团队数据出错, row:', rows);
      }
    } // 操作时 记住当前行星系


    let currentRowIndex = -1;
    let currentRow = ref({}); // 批量删除团队

    function batchDelete() {
      const selectedRows = table.value.getCheckboxRecords();

      if (!selectedRows.length) {
        ElMessage.warning('请选择要删除的团队');
        return;
      } // 从 tableData 中移除选中的行


      const selectedIndexes = selectedRows.map(row => tableData.value.findIndex(item => item.supplier_id === row.supplier_id)).sort((a, b) => b - a); // 从后往前删除，避免索引变化

      selectedIndexes.forEach(index => {
        if (index !== -1) {
          tableData.value.splice(index, 1);
        }
      });
      table.value.loadData(tableData.value);
    } // 关联 厂家/经销商


    function relation(row, index) {
      currentRow.value = row;
      currentRowIndex = index;
      supplierId.value = row.supplier_id;
      showAddSalesManModal.value = true;
    }

    function relationSuccess(rows) {
      // 关联厂家/经销商后 展示关联名称
      tableData.value[currentRowIndex].salesman_branch_name_cover = rows.map(item => item.branch_name).join(','); // 记住关联厂家/经销商 id

      tableData.value[currentRowIndex].salesman_branch_id_cover = rows.map(item => item.branch_id).join(',');
    } // 批量设置角色


    let roleInfo = ref(null);
    let selectedRowsForRole = ref([]);

    function batchSetRole() {
      const selectedRows = table.value.getCheckboxRecords();

      if (!selectedRows.length) {
        ElMessage.warning('请选择要设置角色的团队');
        return;
      } // 保存选中的行数据，用于后续批量更新


      selectedRowsForRole.value = selectedRows; // 使用第一个选中团队的数据作为模板

      const templateRow = selectedRows[0] || {};
      roleInfo.value = _objectSpread(_objectSpread({}, templateRow), {}, {
        // 确保有必要的字段
        businessCategory: templateRow.businessCategory || '1'
      });
      showSetRoleModal.value = true;
    }

    function setRoleSuccess(data) {
      // 只更新选中团队的角色相关字段
      const selectedSupplierIds = selectedRowsForRole.value.map(row => row.supplier_id); // 定义需要更新的角色相关字段

      const roleFields = ['businessCategory', 'employeeType', 'position', 'email', 'employeeCode', 'isLoginWeb'];
      tableData.value = tableData.value.map(row => {
        if (selectedSupplierIds.includes(row.supplier_id)) {
          const updatedRow = _objectSpread({}, row); // 只更新角色相关字段


          roleFields.forEach(field => {
            if (data[field] !== undefined) {
              updatedRow[field] = data[field];
            }
          });

          if (data.employeeType !== undefined) {
            syncAppPermissionsForEmployeeType(updatedRow);
          } else {
            stripInvalidAppPermissionCodes(updatedRow);
          }

          return updatedRow;
        }

        return row;
      });
      showSetRoleModal.value = false; // 清空选中状态

      selectedRowsForRole.value = [];
    } // 编辑部门


    function editDepartment(row, rowIndex) {
      currentDepartmentRowIndex.value = rowIndex;
      currentDepartmentSupplierId.value = row.supplier_id;
      showDepartmentTreeModal.value = true;
    } // 部门选择成功


    function departmentSelectSuccess(departmentData) {
      if (currentDepartmentRowIndex.value !== -1) {
        // 更新当前行的部门信息
        tableData.value[currentDepartmentRowIndex.value].structureName = departmentData.text.replace(/\s*\(.*\)$/, '');
        tableData.value[currentDepartmentRowIndex.value].structureId = departmentData.id;
        tableData.value[currentDepartmentRowIndex.value].departmentBusinessArea = departmentData.busiArea;
        tableData.value[currentDepartmentRowIndex.value].departmentBusinessAreaName = departmentData.busiAreaName;
        tableData.value[currentDepartmentRowIndex.value].salesmanBusinessAreaName = '';
        tableData.value[currentDepartmentRowIndex.value].salesmanBusinessArea = '';
      } // 重置状态


      currentDepartmentRowIndex.value = -1;
    } // 编辑销售区域


    function editSalesArea(row, rowIndex) {
      currentSalesAreaRowIndex.value = rowIndex; // 根据逻辑确定 currentAdcode 的值

      if (row.departmentBusinessArea) {
        currentSalesAreaAdcode.value = row.departmentBusinessArea;
      } else if (row.businessArea) {
        currentSalesAreaAdcode.value = row.businessArea;
      } else {
        ElMessage.warning('团队的销售区域为空，请先为团队设置销售区域');
        return;
      }

      showSalesAreaTreeModal.value = true;
    } // 销售区域选择成功


    function salesAreaSelectSuccess(selectedAreas) {
      if (currentSalesAreaRowIndex.value !== -1) {
        // 更新当前行的销售区域信息
        const areaNames = selectedAreas.map(area => area.text).join(',');
        const areaIds = selectedAreas.map(area => area.id).join(',');
        tableData.value[currentSalesAreaRowIndex.value].salesmanBusinessAreaName = areaNames;
        tableData.value[currentSalesAreaRowIndex.value].salesmanBusinessArea = areaIds;
      } // 重置状态


      currentSalesAreaRowIndex.value = -1;
      currentSalesAreaAdcode.value = '';
    }

    function confirm() {
      formRef.value.validate(e => {
        if (e) {
          let payload = {}; // 校验表格数据

          let checkMsg = '';

          for (const item of tableData.value) {
            if (!item.salesman_branch_id_cover) {
              checkMsg = `请关联${Number(form.value.businessCategory) === 3 ? '厂家' : '发货方'}!`;
              break;
            }

            if (item.structureId && item.employeeType == 1) {
              checkMsg = '部门成员不能设为企业负责人!';
              break;
            }

            if (!item.structureId && item.employeeType == 2) {
              checkMsg = '部门负责人必须设置部门!';
              break;
            }
          }

          if (checkMsg) {
            ElMessage.warning(checkMsg);
            return;
          }

          const salesmanSupplierList = tableData.value.map(i => {
            const auth = rowToAppAuthFields(i);
            i.dataViewAuth = auth.dataViewAuth;
            i.prodManagerAuth = auth.prodManagerAuth;
            i.newUserAuditAuth = auth.newUserAuditAuth;
            i.purchasePriceViewAuth = auth.purchasePriceViewAuth;
            i.supplierCategory = i.supplier_category; // 参数名转换成后台需要的字段名

            i.supUserId = i.sup_user_id;
            i.supplierId = i.supplier_id;
            i.supplierName = i.supplier_name;
            i.salesmanBranchIdCover = i.salesman_branch_id_cover; // supplier_category 1 厂家团队 2 发货方团队
            // 厂家团队默认给 业务员类型 3 商务经理
            // 发货方团队默认给 1 专职

            if (!i.businessCategory) {
              i.businessCategory = i.supplier_category === 1 ? '3' : '1';
            }

            return i;
          });
          addSalesmanMan(_objectSpread(_objectSpread({}, form.value), {}, {
            salesmanSupplierList,
            __repeat: true,
            __warn: false
          })).then(data => {
            if (data.code === '1001') {
              ElMessageBox.confirm(data.msg, '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(() => {
                addSalesmanMan(_objectSpread(_objectSpread({}, form.value), {}, {
                  salesmanSupplierList,
                  comfirmStatus: '1',
                  __repeat: true,
                  __warn: false
                })).then(res => {
                  if (res.success) {
                    visible.value = false;
                    ElMessage.success('操作成功');
                    emit('success');
                  } else {
                    ElMessage.error(data.msg);
                  }
                });
              }).catch(() => {});
            } else if (data.success) {
              visible.value = false;
              ElMessage.success('操作成功');
              emit('success');
            } else {
              ElMessage.error(data.msg);
            }
          });
        }
      });
    }

    const tableOptions = {
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.editData ? '编辑业务员' : '新建业务员',
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "60%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[10] || (_cache[10] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          "label-width": "100px",
          ref_key: "formRef",
          ref: formRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "loginName",
                rules: {
                  required: true,
                  message: '请填写登录账号'
                },
                label: "登录账号"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  disabled: !!__props.editData,
                  modelValue: form.value.loginName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.loginName = $event)
                }, null, 8, ["disabled", "modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "手机号",
                prop: "linkPhone",
                rules: {
                  required: true,
                  message: '请填写手机号'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.linkPhone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.linkPhone = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, null, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "姓名",
                prop: "linkMan",
                rules: {
                  required: true,
                  message: '请填写姓名'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.linkMan,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.linkMan = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注",
                prop: "note"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.note,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.note = $event)
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createVNode(_component_vxe_grid, _mergeProps({
          data: tableData.value,
          ref_key: "table",
          ref: table
        }, tableOptions), {
          tools: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Plus",
            onClick: _cache[4] || (_cache[4] = $event => showAddTeamModal.value = true)
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "success",
            onClick: batchSetRole
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "danger",
            icon: "Delete",
            onClick: batchDelete
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })]),
          isLoginWeb: _withCtx(({
            row
          }) => [_createVNode(_component_el_select, {
            modelValue: row.isLoginWeb,
            "onUpdate:modelValue": $event => row.isLoginWeb = $event,
            placeholder: "请选择",
            style: {
              "width": "100px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              value: "1",
              label: "是"
            }), _createVNode(_component_el_option, {
              value: "0",
              label: "否"
            })]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"])]),
          employeeRole: _withCtx(({
            row
          }) => [_createVNode(_component_el_select, {
            modelValue: row.employeeType,
            "onUpdate:modelValue": $event => row.employeeType = $event,
            placeholder: "请选择",
            style: {
              "width": "120px"
            },
            onChange: $event => onEmployeeTypeChange(row)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              value: 1,
              label: "企业负责人"
            }), _createVNode(_component_el_option, {
              value: 2,
              label: "部门负责人"
            }), _createVNode(_component_el_option, {
              value: 3,
              label: "业务员"
            })]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])]),
          appPermissionCell: _withCtx(({
            row
          }) => [Number(row.employeeType) === 3 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "-")) : Number(row.employeeType) === 2 ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            "model-value": row.appPermissionCodes,
            multiple: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            disabled: !canShowPurchasePricePermOption(row),
            placeholder: "请选择",
            class: "app-perm-select",
            "onUpdate:modelValue": val => onAppPermissionUpdate(row, val)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDeptHeadAppPermOptionsForRow(row), opt => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value,
                disabled: opt.value === APP_PERM_DATA_VIEW
              }, null, 8, ["label", "value", "disabled"]);
            }), 128))]),
            _: 2
          }, 1032, ["model-value", "disabled", "onUpdate:modelValue"])) : (_openBlock(), _createBlock(_component_el_select, {
            key: 2,
            "model-value": row.appPermissionCodes,
            multiple: "",
            "collapse-tags": "",
            "collapse-tags-tooltip": "",
            placeholder: "请选择",
            class: "app-perm-select",
            "onUpdate:modelValue": val => onAppPermissionUpdate(row, val)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getAppPermOptionsForRow(row), opt => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: opt.value,
                label: opt.label,
                value: opt.value,
                disabled: opt.value === APP_PERM_DATA_VIEW
              }, null, 8, ["label", "value", "disabled"]);
            }), 128))]),
            _: 2
          }, 1032, ["model-value", "onUpdate:modelValue"]))]),
          structureCell: _withCtx(({
            row,
            rowIndex
          }) => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(row.structureName || '-'), 1), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            icon: "Edit",
            onClick: $event => editDepartment(row, rowIndex)
          }, null, 8, ["onClick"])])]),
          relationCell: _withCtx(({
            row,
            rowIndex
          }) => [_createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(row.salesman_branch_name_cover || '-'), 1), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            icon: "Edit",
            onClick: $event => relation(row, rowIndex)
          }, null, 8, ["onClick"])])]),
          businessAreaCell: _withCtx(({
            row,
            rowIndex
          }) => [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString(row.salesmanBusinessAreaName || '-'), 1), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            icon: "Edit",
            onClick: $event => editSalesArea(row, rowIndex)
          }, null, 8, ["onClick"])])]),
          _: 1
        }, 16, ["data"]), _createVNode(AddTeamModal, {
          modelValue: showAddTeamModal.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showAddTeamModal.value = $event),
          onSuccess: addSuccess
        }, null, 8, ["modelValue"]), _createVNode(RelationSupplierBranchModal, {
          modelValue: showAddSalesManModal.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showAddSalesManModal.value = $event),
          businessCategory: _unref(currentRow).businessCategory,
          supplierId: supplierId.value,
          onSuccess: relationSuccess
        }, null, 8, ["modelValue", "businessCategory", "supplierId"]), _createVNode(SetRoleModal, {
          modelValue: showSetRoleModal.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showSetRoleModal.value = $event),
          onSuccess: setRoleSuccess,
          editData: _unref(roleInfo)
        }, null, 8, ["modelValue", "editData"]), _createVNode(DepartmentTreeModal, {
          modelValue: showDepartmentTreeModal.value,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showDepartmentTreeModal.value = $event),
          supplierId: currentDepartmentSupplierId.value,
          onSuccess: departmentSelectSuccess
        }, null, 8, ["modelValue", "supplierId"]), _createVNode(SalesAreaTreeModal, {
          modelValue: showSalesAreaTreeModal.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => showSalesAreaTreeModal.value = $event),
          currentAdcode: currentSalesAreaAdcode.value,
          onSuccess: salesAreaSelectSuccess
        }, null, 8, ["modelValue", "currentAdcode"])]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }

};